import { render, staticRenderFns } from "./AmazePhotoUpload.vue?vue&type=template&id=3d084efc&scoped=true"
import script from "./AmazePhotoUpload.vue?vue&type=script&lang=js"
export * from "./AmazePhotoUpload.vue?vue&type=script&lang=js"
import style0 from "./AmazePhotoUpload.vue?vue&type=style&index=0&id=3d084efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d084efc",
  null
  
)

export default component.exports